







import { Component, Vue, Prop } from 'vue-property-decorator';
import { State, Getter } from 'vuex-class';
import { Service, TableField } from '@/types';
import ServiceVersions from './ServiceVersions.vue';

@Component({
  name: 'service-info',
  components: {
    ServiceVersions
  }
})
export default class ServiceInfo extends Vue {
  @Prop({ required: true, type: Object })
  service!: Service;

  items: Service[] = [this.service];
  fields: TableField[] = [
    { key: 'dns_name', label: 'DNS Name' },
    { key: 'slug', label: 'Slug' }
  ];
}
